<mat-toolbar class="toolbar">
      <a routerLink="/" aria-label="Home" class="logo-link">
        <img src="logo-wide.svg" alt="BOLOARENA Logo" class="app-logo" />
      </a>

      <span class="spacer"></span>

      <ng-container *ngIf="!(authService.loading$ | async); else loadingTemplate">
        <!-- Desktop View -->
        <div class="desktop-menu" *ngIf="authService.user$ | async as user; else guestLinks">
          <button mat-button routerLink="/dashboard" class="nav-btn">Dashboard</button>
          <button mat-button routerLink="/places" class="nav-btn">Places</button>
          <button mat-button routerLink="/leagues" class="nav-btn">Standings</button>
          <button mat-button *ngIf="user.role === 'admin' || user.role === 'super_admin'" routerLink="/admin" class="nav-btn">Admin</button>

          <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu-btn">
            <span class="user-menu-content">
              <span class="player-id-badge" *ngIf="user.shortCode">{{ user.shortCode }}</span>
              <img *ngIf="user.photoURL" [src]="user.photoURL" class="header-avatar" alt="Avatar">
              <mat-icon *ngIf="!user.photoURL" class="header-icon-avatar">account_circle</mat-icon>
              <span class="user-name">{{ user.displayName }}</span>
              <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
            </span>
          </button>

          <mat-menu #userMenu="matMenu">
            <button mat-menu-item routerLink="/profile">
              <mat-icon>person</mat-icon>
              <span>Profile</span>
            </button>
            <button mat-menu-item (click)="confirmLogout()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>

        <ng-template #guestLinks>
          <div class="desktop-menu">
            <button mat-button routerLink="/places" class="nav-btn">Places</button>
            <button mat-button routerLink="/auth/login" class="nav-btn">Login</button>
            <button mat-button routerLink="/auth/register" class="nav-btn">Register</button>
          </div>
        </ng-template>

        <!-- Mobile Menu Button -->
        <button mat-icon-button class="mobile-menu-btn" [matMenuTriggerFor]="menu" aria-label="Menu">
          <mat-icon>menu</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <ng-container *ngIf="authService.user$ | async as user; else mobileGuestLinks">
            <button mat-menu-item routerLink="/dashboard">
              <mat-icon>dashboard</mat-icon>
              <span>Dashboard</span>
            </button>
            <button mat-menu-item routerLink="/places">
              <mat-icon>place</mat-icon>
              <span>Places</span>
            </button>
            <button mat-menu-item routerLink="/leagues">
              <mat-icon>emoji_events</mat-icon>
              <span>Standings</span>
            </button>
            <button mat-menu-item *ngIf="user.role === 'admin' || user.role === 'super_admin'" routerLink="/admin">
              <mat-icon>admin_panel_settings</mat-icon>
              <span>Admin</span>
            </button>

            <mat-divider></mat-divider>

            <button mat-menu-item routerLink="/profile">
              <mat-icon>person</mat-icon>
              <span>Profile ({{ user.displayName }}) <span class="player-id-badge-mobile" *ngIf="user.shortCode">{{ user.shortCode }}</span></span>
            </button>
            <button mat-menu-item (click)="confirmLogout()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </button>
          </ng-container>

          <ng-template #mobileGuestLinks>
            <button mat-menu-item routerLink="/places">
              <mat-icon>place</mat-icon>
              <span>Places</span>
            </button>
            <button mat-menu-item routerLink="/auth/login">
              <mat-icon>login</mat-icon>
              <span>Login</span>
            </button>
            <button mat-menu-item routerLink="/auth/register">
              <mat-icon>person_add</mat-icon>
              <span>Register</span>
            </button>
          </ng-template>
        </mat-menu>
      </ng-container>

      <ng-template #loadingTemplate>
        <div class="desktop-menu">
           <mat-spinner diameter="30" color="accent"></mat-spinner>
        </div>
      </ng-template>

    </mat-toolbar>
